import { put, takeLatest } from "redux-saga/effects";

import {
  fetchBankDetailsListRequest,
  fetchBankDetailsListFailure,
  fetchBankDetailsListSuccess,
  BankDetailsCreateRequest,
  BankDetailsCreateSuccess,
  BankDetailsCreateFailure,
  BankDetailsUpdateRequest,
  BankDetailsUpdateSuccess,
  BankDetailsUpdateFaliure,
} from "redux/reducers/acclgl/bank-details";
import {
  requestBankDetailsList,
  requestBankDetailsCreate,
  requestBankDetailsUpdate,
} from "services/acclgl/bank-details";
export function* watchbankDetails() {
  yield takeLatest(fetchBankDetailsListRequest, fetchbankdetailslist);
  yield takeLatest(BankDetailsCreateRequest, createBankDetailslist);
  yield takeLatest(BankDetailsUpdateRequest, updatebankDetailslist);
}

function* fetchbankdetailslist({ payload }) {
  try {
    const response = yield requestBankDetailsList(payload);
    yield put(fetchBankDetailsListSuccess(response));
  } catch (error) {
    yield put(fetchBankDetailsListFailure("Failed to get list"));
  }
}

function* createBankDetailslist({ payload }) {
  try {
    //service add
    const response = yield requestBankDetailsCreate(payload);
    yield put(BankDetailsCreateSuccess(response.data));
  } catch (error) {
    if (error?.response?.data?.data?.code === 11000) {
      yield put(BankDetailsCreateFailure("Account Number Alreday In use."));
    } else {
      yield put(BankDetailsCreateFailure("Failed to create Bank Details"));
    }
  }
}
function* updatebankDetailslist({ payload }) {
  try {
    const response = yield requestBankDetailsUpdate(payload);
    yield put(BankDetailsUpdateSuccess(response.data));
  } catch (error) {
    if (error?.response?.data?.data?.code === 11000) {
      yield put(BankDetailsUpdateFaliure("Account Number Alreday In use."));
    } else {
      yield put(BankDetailsUpdateFaliure("Failed to Update Bank Details"));
    }
  }
}
